import { type FC, memo } from "react"
import styled from "styled-components"

import Button from "~/components/Button"
import { DefaultModal, ModalButtons, ModalContentPadding, ModalText, ModalTitle } from "~/components/Modal"
import { usePlatform, useUser } from "~/contexts/UserContext"
import { query } from "~/utilities/trpc"

import oldImage from "~/assets/themes/legacy.png"
import newImage from "~/assets/themes/modern.png"

const NewThemeModal: FC = () => {
	const user = useUser()
	const platform = usePlatform()!

	const isOpen = platform.theme.id === "legacy" && !platform.theme.hasChosen

	const { mutate, isPending, variables } = query.platform.update.useMutation({ onSuccess: () => user.reload() })

	return (
		<DefaultModal width={1000} isOpen={isOpen}>
			<ModalTitle>New academy theme! 🎉</ModalTitle>
			<ModalText>
				We've launched a new academy theme, and we really like it! Would you like to switch to it? You can
				switch back at any time in your settings!
			</ModalText>
			<Themes>
				<Theme>
					<ThemeLabel>Current theme</ThemeLabel>
					<ThemeImage alt="Current theme" src={oldImage} />
				</Theme>
				<Theme>
					<ThemeLabel>New theme</ThemeLabel>
					<ThemeImage alt="New theme" src={newImage} />
				</Theme>
			</Themes>
			<ModalButtons>
				<Button
					variant="secondary"
					onClick={() => mutate({ themeId: "legacy" })}
					isDisabled={isPending}
					isLoading={isPending && variables?.themeId === "legacy"}
				>
					No thanks
				</Button>
				<Button
					variant="primary"
					onClick={() => mutate({ themeId: "modern" })}
					isDisabled={isPending}
					isLoading={isPending && variables?.themeId === "modern"}
				>
					Yes, switch! 🚀
				</Button>
			</ModalButtons>
		</DefaultModal>
	)
}

const Themes = styled(ModalContentPadding)`
	display: flex;
	gap: 16px;
`

const Theme = styled.div`
	flex: 1 0 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
`

const ThemeLabel = styled.div`
	font-size: 14px;
	color: #757575;
	text-align: center;
`

const ThemeImage = styled.img`
	width: 100%;
	border-radius: 8px;
`

export default memo(NewThemeModal)
